<template>
    <div class="form-row">
        <iframe :src="pageSrc"  height="1000" style="width:100%;border:none;padding:0 5px;"></iframe>
    </div>
</template>

<script>
export default {
    name:'CampaignDetailIframe',
    data() {
        return {
            sortList: ['Status', 'Active', 'Keywords', 'Match', 'CPC Bid', 'Bid Status', 'Impressions', 'Clicks', 'CTR', 'ACPC', 'Spend', 'Sales', 'ACOS'],
			pageSrc:'',
        }
    },
	beforeMount() {
		console.log('mounted');
		this.pageSrc= `/campaign_edit-details.html?brandId=&campaignId=${this.$route.params.campaignId}&campaignName=${this.$route.params.campaignName}`
    }
}
</script>

<style scoped src="@/assets/css/main.css">

</style>
<style lang="scss">

</style>
